import React from 'react';
import CancelAlertPopup from 'src/pages/reportUsage/common/cancelAlertPopup';
import SurgeryOrderNonUsePopup from 'src/pages/reportUsage/review/components/SurgeryOrderNonUsePopup';
import UnidPlanPdfNotAvailable from 'src/pages/scheduleSurgery/components/surgery/notifications/UnidPlanPdfNotAvailable';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const ReportUsagePopupContainer = ({
    showUNiDPopUp,
    isReplishBtnClicked,
    discardUNiDChangesBtnClickHandler,
    closeCancelAlertPopup,
    isPriceOverride,
    showCancelPopUp,
    showUnsavedChangesPopup,
    isProcedureBtnClicked,
    discardChangesBtnClickHandler,
    showSurgeryNonUsePopup,
    setShowSurgeryNonUsePopup,
    submitUsageOrder,
    pdfNotAvailable,
    setPdfNotAvailable,
}) => {
    const { t } = useTranslation();
    const usageDetails = useSelector(
        (state) => state.reportUsageRootReducer?.usageDetails
    );
    return (
        <>
            {showUNiDPopUp && (
                <CancelAlertPopup
                    popupTitle={
                        isReplishBtnClicked
                            ? (usageDetails?.vendorCaseId?.startsWith('UH_') ||
                                  usageDetails?.vendorCaseId?.startsWith(
                                      'AH_'
                                  )) &&
                              t('procedure.NoUNiDUsage')
                            : ''
                    }
                    alertMessage={
                        isReplishBtnClicked
                            ? (usageDetails?.vendorCaseId?.startsWith('UH_') ||
                                  usageDetails?.vendorCaseId?.startsWith(
                                      'AH_'
                                  )) &&
                              t('procedure.msgss')
                            : ''
                    }
                    btn1Label={
                        isReplishBtnClicked
                            ? t(
                                  'reportUsage.record.reportPayment.ReportPayment.yes'
                              )
                            : ''
                    }
                    btn2Label={
                        isReplishBtnClicked
                            ? t(
                                  'reportUsage.record.reportPayment.ReportPayment.no'
                              )
                            : ''
                    }
                    btn1ClickHandler={discardUNiDChangesBtnClickHandler}
                    btn2ClickHandler={closeCancelAlertPopup}
                    isReplishBtnClicked={isReplishBtnClicked}
                    fromPriceOverride={isPriceOverride}
                />
            )}
            {(showCancelPopUp || showUnsavedChangesPopup) && (
                <CancelAlertPopup
                    popupTitle={
                        isProcedureBtnClicked
                            ? t(
                                  'reportUsage.record.reportPayment.ReportPayment.UnappliedShipto'
                              )
                            : isPriceOverride
                            ? t('equity.unsavedChanges.priceOverrideTitle')
                            : t(
                                  'scheduleSurgery.surgery.notifications.UnsavedChanges.UnSavedChanges'
                              )
                    }
                    alertMessage={
                        isProcedureBtnClicked
                            ? t(
                                  'reportUsage.record.reportPayment.ReportPayment.mitemsmsg'
                              )
                            : isPriceOverride
                            ? t(
                                  'equity.unsavedChanges.priceOverrideWarningMessage'
                              )
                            : t(
                                  'scheduleSurgery.surgery.notifications.UnsavedChanges.unSavedChangesLostText'
                              )
                    }
                    btn1Label={
                        isProcedureBtnClicked
                            ? t(
                                  'reportUsage.record.reportPayment.ReportPayment.yes'
                              )
                            : t(
                                  'scheduleSurgery.surgery.notifications.UnsavedChanges.discardChangesAndExitBtn'
                              )
                    }
                    btn2Label={
                        isProcedureBtnClicked
                            ? t(
                                  'reportUsage.record.reportPayment.ReportPayment.no'
                              )
                            : t(
                                  'scheduleSurgery.surgery.notifications.UnsavedChanges.continueEditingBtn'
                              )
                    }
                    btn1ClickHandler={discardChangesBtnClickHandler}
                    btn2ClickHandler={closeCancelAlertPopup}
                    isProcedureBtnClicked={isProcedureBtnClicked}
                    fromPriceOverride={isPriceOverride}
                />
            )}
            {showSurgeryNonUsePopup && (
                <SurgeryOrderNonUsePopup
                    submitUsageOrder={submitUsageOrder}
                    returnToOrderClickHandler={() =>
                        setShowSurgeryNonUsePopup(false)
                    }
                />
            )}
            {pdfNotAvailable && (
                <UnidPlanPdfNotAvailable
                    onClose={() => setPdfNotAvailable(false)}
                />
            )}
        </>
    );
};

export default ReportUsagePopupContainer;
